<template>
  <div class="panel">
    <div class="navigation">
      <Breadcrumbs v-if="maybeItem" :itemID="content.id" />
      <button class="md-icon close-btn" @click="closePanel">close</button>
    </div>
    <ItemHeader
      v-if="content.header && maybeItem"
      class="heading no-icon"
      :itemID="content.id"
    />
    <HelpHint
      v-if="!content.noHint && content.header && maybeItem"
      :itemID="content.id"
    />
    <component :is="content.component" :itemID="content.id" :class="{singleList}"/>
    <button class="backbtn" v-if="singleList && isMainPanel" @click="$router.back()">wstecz</button>
    <button v-if="canSwitchView" class="fab" @click="switchView">
      <div class="md-icon">view_week</div>
    </button>
  </div>
</template>

<style scoped>
.backbtn {
  max-width: 160px;
  margin: 0 8px;
  padding: 8px;
  background: var(--card-color-default);
}

.panel {
  display: flex;
  flex-direction: column;
}
.navigation {
  display: flex;
  flex-direction: row;
}
.heading {
  font-size: 20px;
  font-weight: bold;
  padding: 8px;
}

.fab {
  background-color: #f7f7f7;
  border: 1px solid #ddd;
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 48px;
  height: 48px;
}

.close-btn {
  position: absolute;
  right: 0;
  top: 0;
  width: var(--medium-button-size);
  height: var(--medium-button-size);
  background-color: var(--bg-color-main);
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-panel .close-btn {
  display: none;
}
.split-panel .fab {
  display: none;
}
</style>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import ItemHeader from "@/components/ItemHeader.vue";
import TimeList from "../components/TimeList.vue";
import OldCalendar from "./old-calendar.vue";
import Notepad from "../views/notepad.vue";
import HorizontalView from "../views/horizontal.vue";
import ItemList from "../components/ItemList.vue";
import WeekWithDays from "@/components/WeekWithDays.vue";
import { resolveCurrent } from "@/time-utils";
import { DATE_UNITS, supportedViews } from "../structure";
import { maybeGetItem } from "@/reactive-cache";
import router from "../router";
import settings from "@/synced-settings";
import HelpHint from "@/components/HelpHint.vue";
import Calendar from "@/views/calendar.vue";
import BoardView from "../views/board.vue"

export default {
  name: "Section",
  props: ["itemID", "position"],
  components: {
    Notepad,
    HorizontalView,
    TimeList,
    OldCalendar,
    Breadcrumbs,
    ItemHeader,
    ItemList,
    WeekWithDays,
    HelpHint,
    Calendar,
    BoardView,
  },
  computed: {
    isMainPanel() {
      return this.position !== "side";
    },
    maybeItem() {
      return maybeGetItem(resolveCurrent(this.itemID));
    },
    content() {
      const id = resolveCurrent(this.itemID);
      switch (true) {
        case this.maybeItem?.type === "layout":
          return { id, component: BoardView, header: true };
        case id === "notepad":
          return { id, component: Notepad, header: true };
        case id === "old-calendar":
          return { id, component: OldCalendar, header: true };
        case id === "calendar":
          return { id, component: Calendar, header: false };
        case id.startsWith("week:"):
          return { id, component: WeekWithDays, header: false };
        case DATE_UNITS.includes(id.slice(0, -1)):
          return { id, component: TimeList, header: false };
        case this.isMainPanel && id.startsWith("root:"):
          return { id, component: HorizontalView, header: false };
        case this.isMainPanel && this.$route.query?.mainView === "horizontal":
          return { id, component: HorizontalView, header: false };
        default:
          return { id, component: ItemList, header: false, singleList: true };
      }
    },
    singleList() {
      return this.content.singleList;
    },
    canSwitchView() {
      if (!this.maybeItem) return false;
      return settings.altViews && supportedViews(this.maybeItem).length > 1;
    },
  },
  methods: {
    switchView() {
      if (this.maybeItem) {
        router.switchView(this.maybeItem);
      }
    },
    // TODO make it work for any panel
    closePanel() {
      router.closeSideView();
    },
  },
};
</script>
